var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.inputContainerClass},[_c('v-text-field',{attrs:{"max":_vm.max,"min":_vm.min},on:{"input":_vm.handleInput},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }